<template>
  <b-table
    :fields="fields"
    :items="items"
    @row-clicked="onClickRow"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    @sort-changed="onSortChanged"
    table-class="text-nowrap"
    responsive
    hover
  >
    <template #cell(name)="data">
      <div class="d-flex align-items-center">
        <div v-if="!noAvatar" class="mr-2">
          <user-avatar :key="data.item.user.id" :user="data.item.user" size="40px"/>
        </div>
        <div>
          <h4 class="mb-0">
            <b-link :to="{name: 'admin-user', params: {id: data.item.user.id.toString()}}">
              {{ data.item.full_name }}
            </b-link>
          </h4>
        </div>
      </div>
    </template>
    <template #cell(company)="data">
      <div class="d-flex align-items-center">
        <div v-if="!noAvatar">
          {{ data.item.company }}
        </div>
        <b-badge v-if="data.item.user.is_hijacking" variant="danger" class="ml-3">Hijacking</b-badge>
      </div>
    </template>
    <template #cell(status)="data">
      <b-badge v-if="data.item.user.is_active" variant="success">Active</b-badge>
      <b-badge v-else variant="danger">Inactive</b-badge>
    </template>
  </b-table>
</template>

<script>
import UserAvatar from "./UserAvatar";
import {convertFromUtc} from "../helpers";
export default {
  name: "AdminUsersTable",
  components: {UserAvatar},
  props: {
    users: Array,
    noAvatar: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    sortBy: String,
    sortDesc: Boolean
  },
  data() {
    return {
      fields: this.getTableFields()
    }
  },
  computed: {
    items() {
      return this.users.map(user => {
        return {
          user: user,
          full_name: user.first_name + ' ' + user.last_name,
          email: user.email,
          role: user.role?.name,
          company: user.company?.name,
          date_added: convertFromUtc(user.created_at, 'L')
        }
      })
    }
  },
  methods: {
    onSortChanged(sort) {
      this.$emit('sort-changed', sort);
    },
    getTableFields() {
      let fields = [
        {
          key: "name",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "email",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "role",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "status",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "company",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer"
        },
        {
          key: "date_added",
          thClass: "border-top-0",
          tdClass: "align-middle cursor-pointer",
          sortable: true
        },
      ];
      if (this.small) {
        fields = [
          {
            key: "name",
            thClass: "border-top-0",
            tdClass: "cursor-pointer"
          },
          {
            key: "role",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "company",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
          {
            key: "date_added",
            thClass: "border-top-0",
            tdClass: "align-middle cursor-pointer"
          },
        ]
      }

      return fields;
    },
    onClickRow(item) {
      let userId = item.user.id;
      this.$router.push({ name: "admin-user", params: { id: userId.toString() } });
    }
  }
}
</script>
